// extracted by mini-css-extract-plugin
export default {"container":"aQ-z","topReviewHeading":"bQ-z","criticalReview":"cQ-z","favorableReview":"dQ-z","vsSeparator":"eQ-z"};